import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import Flex from '../../components/Flex'
import Box from '../../components/Box'
import { FormattedMessage } from 'react-intl'
import CodeElement from './CodeElement'
/* istanbul ignore next */
function copyToClipboard (element) {
    element.current && navigator.clipboard.writeText(element.current.outerText)
}

const CodeElementContainer = ({children, name, width, customCodeElement: CustomCodeElement, customCodeProps}) => {
    const [showFields, setShowFields] = useState(false)
    const [showMessage, setShowMessage] = useState(false)
    const textAreaRef = useRef()
    const copyButtonText = showMessage ? /* istanbul ignore next */<FormattedMessage id='copied-button-text' defaultMessage='Copied'/> : <FormattedMessage id='copy-button-text' defaultMessage='Copy to clipboard'/>
    return (
        <Flex flexDirection='row' width={width}>
            <Flex flexDirection='column' width={width}>
            <Box
                key='codeblock'
                minWidth='300px'
                background='#EEE'
                color='gray'
                fontSize='0.8em'
                border='1px solid #DDD'
                padding='2em'
                borderRadius='3px'
                lineHeight='1.4em'
                ref={(textArea) => textAreaRef.current = textArea}>
                    {CustomCodeElement ?
                        <CustomCodeElement /> :
                        <CodeElement dataTest='code-element' name={name} customCodeProps={customCodeProps} showFields={showFields}>{children}</CodeElement>
                    }
            </Box>

            <Flex key='clipboard' >
                <Box width='50%' fontSize='0.7em' padding='0.3em'>
                    <input id='show-no-knobs-button' type='checkbox' onClick={() => setShowFields(!showFields)} />
                    <span>Show no-Knobs props</span>
                </Box>
                <Flex textAlign='right' justifyContent='end' width='50%'>
                    <button
                        style={{
                            marginTop: '0.2em',
                            display: 'inline-flex',
                            padding: '0.2em 0.5em',
                            background:'gray',
                            color: /* istanbul ignore next */showMessage ? 'gold' :'white',
                            fontSize: '0.7em',
                            border: '1px solid #DDD',
                            alignItems: 'center',
                            cursor: /* istanbul ignore next */showMessage ? 'default' :'pointer',
                            width: '125px'
                        }}
                        onClick={/* istanbul ignore next */() => {
                            setShowMessage(true)
                            copyToClipboard(textAreaRef)
                            setTimeout(() => setShowMessage(false), 2000)
                            }}>
                        <span style={{ marginRight: '0.3em', fontSize: '2em' }}>⎘</span> {copyButtonText}
                    </button>
                </Flex>
            </Flex>
        </Flex>
    </Flex>
    )
}

CodeElementContainer.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.element),
    ]),
    name: PropTypes.string,
    width: PropTypes.string,
    customCodeProps: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.string
    })),
    customCodeElement: PropTypes.elementType,
}
CodeElementContainer.defaultProps = {
    name: null,
    width: '300px',
    customCodeProps: [],
    customCodeElement: undefined
}
export default CodeElementContainer
